<template>
  <b-row class="mt-2">
    <b-col
      cols="12"
      md="4"
    >
      <meet />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <country />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <city />
    </b-col>
    <b-col
      class="text-center"
      cols="12"
    >
      <b-button
        variant="primary"
        @click="filterAction"
      >
        <FeatherIcon icon="FilterIcon" /> Filtrele
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import Meet from '@/views/Admin/Suppliers/FilterData/Meet.vue'
import Country from '@/views/Admin/Suppliers/FilterData/Country.vue'
import City from '@/views/Admin/Suppliers/FilterData/City.vue'

export default {
  name: 'FilterData',
  components: {
    BRow,
    BCol,
    BButton,
    Meet,
    Country,
    City,
  },
  props: {
    filterAction: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
